import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { General_Interface } from '../../../Interface/General_Interface';
import { PM_V2_Due_Equipment_Filter_Interface, PM_V2_Due_Equipment_Interface } from '../../../Interface/PM_V2_Interface';
import { AlertifyService } from '../../../Service/Alertify.service';
import { DeviceGroupService } from '../../../Service/DeviceGroup/DeviceGroup.service';
import { PM_V2_Service } from '../../../Service/PM_V2/PM_V2.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-pm-v2-due-list',
  templateUrl: './PM_V2_DueList.component.html',
  styleUrls: ['./PM_V2_DueList.component.css']
})
export class PM_V2_DueListComponent implements OnInit {
  DataList: PM_V2_Due_Equipment_Interface[] = [];
  GroupList: General_Interface[] = [];
  SubGroupList: General_Interface[] = [];
  Procssing = false;
  page = 1;
  FilterForm: FormGroup = this.fb.group({
    TemplateTitle: [''],
    Active: [true],
    GroupId: [0],
    SubGroupId: [0],
    Keyword: [''],
    DueWindow: ['all']
  });

  constructor(
    private fb: FormBuilder,
    private service: PM_V2_Service,
    private groupService: DeviceGroupService,
    private router: Router,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService) { }

  ngOnInit(): void {
    this.groupService.GetDeviceGroup(0).subscribe(
      data => this.GroupList = data || [],
      () => this.Alertify_Service.ErrorMessage('خطا در دریافت گروه‌های تجهیز.'));

    this.Nav_Service.CheckValidPage(2240).subscribe(
      () => this.ReadData(),
      () => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      });
  }

  ReadData() {
    this.Procssing = true;
    const value = this.FilterForm.getRawValue();
    const filter: PM_V2_Due_Equipment_Filter_Interface = {
      TemplateTitle: (value.TemplateTitle || '').trim(),
      Active: value.Active === true,
      GroupId: Number(value.GroupId || 0),
      SubGroupId: Number(value.SubGroupId || 0),
      Keyword: (value.Keyword || '').trim(),
      DueWindow: value.DueWindow || 'all'
    };
    this.service.GetDueEquipmentList(filter).subscribe(data => {
      this.DataList = data || [];
      this.page = 1;
      this.Procssing = false;
    }, () => {
      this.Procssing = false;
      this.Alertify_Service.ErrorMessage('خطا در دریافت تجهیزات آماده اجرای PM.');
    });
  }

  ReadSubGroups() {
    const groupId = Number(this.FilterForm.get('GroupId')?.value || 0);
    this.FilterForm.patchValue({ SubGroupId: 0 });
    this.SubGroupList = [];
    if (groupId <= 0) return;

    this.groupService.GetDeviceGroup(groupId).subscribe(
      data => this.SubGroupList = data || [],
      () => this.Alertify_Service.ErrorMessage('خطا در دریافت زیرگروه‌های تجهیز.'));
  }

  Detail(item: PM_V2_Due_Equipment_Interface) {
    this.router.navigate(['/pm-v2/due/equipment', item.Equipment_ID]);
  }
}
